module.exports = __webpack_public_path__ + "3796904cf59e1ce8c03b11adaf2d982b.png";